import { render, staticRenderFns } from "./Saigai.vue?vue&type=template&id=a4d2e390&scoped=true&"
import script from "./Saigai.vue?vue&type=script&lang=js&"
export * from "./Saigai.vue?vue&type=script&lang=js&"
import style0 from "./Saigai.vue?vue&type=style&index=0&id=a4d2e390&scoped=true&lang=css&"
import style1 from "./Saigai.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d2e390",
  null
  
)

export default component.exports